const gql = require('graphql-tag');

const PDC_HELP_LINK_URL = gql`
    query ($siteName: String!) {
        getAppConfig(name: $siteName) {
            urls {
                r2d2HelpLinkUrl
            }
        }
    }
`;

export default PDC_HELP_LINK_URL;
